import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaMonthFree',
			dom: {
				minutes: '.js-month-free-minutes'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.minutes = false;
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$minutes = this.$el.find(this.options.dom.minutes);
		return this;
	}

	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.monthFree) {
				this.minutes = yotaPortlets.monthFree.minutes;
				this.getDom();
				this.$minutes.text(this.minutes + ' ' + this.declOfNum(this.minutes, ['минуту', 'минуты', 'минут']));

			} else {
				console.error('The monthFree portlet has no data, set data to "yotaPortlets.monthFree"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/month-free/month-free.js